import './GetStarted.scss';
import { useState } from 'react';
import {Stack, Container, Button, Row, Col, Modal, Form} from 'react-bootstrap';
import { ArrowRight } from 'react-bootstrap-icons';

function GetStarted() {
    const [show, setShow] = useState(false);
    
      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);
      const [modalShow, setModalShow] = useState(false);
      
    
      const [validated, setValidated] = useState(false);
    
      const handleSubmit = (event) => {
          const form = event.currentTarget;
          
          // 1. Stop processing if the browser validation rules fail
          if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              setValidated(true);
              return; // Stop code execution here
          }
    
          // 2. If valid, prevent the browser from reloading the page entirely
          event.preventDefault();
          setValidated(true);
    
          // 3. Extract your data fields directly out of the form elements
          const formData = new FormData(form);
          const emailSubject = formData.get('subject_field_name'); // Match your Input 'name' attribute
          const emailMessage = formData.get('message_field_name'); // Match your Input 'name' attribute
      
          const recipient = "cubetechstudio@gmail.com";
    
          // 4. Construct the encoded mailto payload string
          const mailtoUrl = `mailto:${recipient}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailMessage)}`;
    
          // 5. Fire the email client application layout trigger
          window.location.href = mailtoUrl;
    
          
        const rawDigits = phone.replace(/\D/g, '');
      
      };
    
    
      const [phone, setPhone] = useState('');
    
      const handlePhoneChange = (e) => {
        // 1. Remove all non-numeric characters typing inputs
        const input = e.target.value.replace(/\D/g, '');
        
        // 2. Limit the storage to maximum 10 digits
        const cleanInput = input.substring(0, 10);
        
        // 3. Apply structural dash masking steps dynamically
        let formatted = '';
        if (cleanInput.length <= 4) {
          formatted = cleanInput;
        } else if (cleanInput.length <= 7) {
          formatted = `${cleanInput.slice(0, 4)}-${cleanInput.slice(4)}`;
        } else {
          formatted = `${cleanInput.slice(0, 4)}-${cleanInput.slice(4, 7)}-${cleanInput.slice(7)}`;
        }
    
        setPhone(formatted);
      }; 

  return (
        <Stack gap={6} className="get-started">
            <Container className='started-container'>
                <div className='icon'>🚀</div>
                <div className='content'>
                    <h1>Let’s Build Something Extraordinary Together</h1>
                    <div>
                    Partner with CubeTechWorld to create powerful, intelligent, and beautifully designed digital solutions that grow your business and inspire your audience.
                    </div>
                </div>
                  <Button variant="danger" className='my-4' onClick={() => setModalShow(true)}>Get Started <ArrowRight className='btn-arrow' /></Button>

                  <Modal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Business Enquiries</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Container>
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                          <Row>
                            <Col xs={12} md={6}> 
                              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Name*</Form.Label>
                                <Form.Control type="text" placeholder="" required />
                              </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Phone Number*</Form.Label>
                                <Form.Control type="text" placeholder="0000-000-000" value={phone} onChange={handlePhoneChange} required />
                              </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                  <Form.Label>Email*</Form.Label>
                                  <Form.Control type="email" placeholder="name@example.com" required />
                                </Form.Group>
                            </Col>
                        
                            <Col xs={12} md={6}>
                              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                              <Form.Label>Services*</Form.Label>
                                <Form.Select aria-label="Default select example">
                                  <option value={'Marketing'} selected>Digital Marketing</option>
                                  <option value={'Branding'}>Corporate Branding</option>
                                  <option value={'Website'}>Website Design & Development</option>
                                  <option value={'Advertisement'}>Advertisement Campaigns</option>
                                  <option value={'Environment'}>Environment Graphics</option>
                                  <option value={'Panel'}>Exhibition Panel Design</option>
                                  <option value={'Presentations'}>Presentations</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                          <Form.Label>Describe Requirment</Form.Label>
                          <Form.Control as="textarea" rows={3} />
                        </Form.Group>
                        <div className="d-grid gap-2">
                          <Button variant="danger"  type='submit'>
                            Submit
                          </Button>
                        </div>
                      </Form>
                      </Container>
                    </Modal.Body>
                        
                  </Modal>
            </Container>
        </Stack>
    );
}

export default GetStarted;